import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_UnifiedLegalComfort3BasicRolandDe } from '@flows/insurance/schemas'

const legal_tenant = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('coverage_legal_comfort_3_tenant_roland_de_enabled')]:
        BaseSchema_UnifiedLegalComfort3BasicRolandDe.shape
          .coverage_legal_comfort_3_tenant_roland_de_enabled,
    }),
    stepContent: [
      {
        type: 'title',
        text: { type: 'translatableText', translationKey: 'sharedFlows_legal:steps.tenant.title' },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath(
          'coverage_legal_comfort_3_tenant_roland_de_enabled'
        ),
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.tenant.info.text',
        },
        title: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.tenant.info.title',
        },
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'legal_criminal',
  }) as const satisfies AnyStepConfiguration

export default legal_tenant
